<template>
    <div class="flex">
        <img class="point" @click="$router.push('/store/list')" src="https://pic.rmb.bdstatic.com/bjh/f73156c1bd6e700305a6a8ac4023e454.png" alt="">
        <div class="marginL-20">
            <div>
                <el-button v-for="(item, index) in warehouseList" :key="index" @click="selectEvent(item.id)" type="danger" :plain="select != item.id">{{item.express_name}}</el-button>
            </div>
            <div class="text-right fc-666 more-pr"><span class="point" @click="$router.push('/store/list')">更多 ></span></div>
            <div class="product-list flex marginT-10">
                <div v-for="(item, index) in productList" :key="index" class="item point" @click="$router.push(`/store/list/details/${item.id}`)">
                    <img :src="item.othumb" alt="">
                    <div class="intro">
                        <div class="fs-14 fc-666">{{item.product_name}}</div>
                        <div class="flex flex-between fc-999 align-center">
                            <div v-if="!$store.state.token" class="fc-theme fs-14" @click.stop="$bus.emit('openLogin')">登录后查看</div>
                            <div v-else class="fc-theme fs-22">￥{{item.sale_price}}</div>
                            <div class="fs-12">重量：{{item.weight}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        wareHouse: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            select: null,
            warehouseList: [],
            productList: [],
        }
    },
    methods: {
        // async getWarehouse() {
        //     const data = await this.$fetch('/shop/webs/v1/get-warehouse-list', {page: 1, pageSize: 10}, 'post')
        //     if (data.code == 0) {
        //         this.warehouseList = data.data
        //         this.select = this.warehouseList[0].id
        //         this.getProduct(this.warehouseList[0].id)
        //     }
        // },
        async getProduct(id) {
            const data = await this.$fetch('/shop/webs/v1/get-product-list', {page: 1, pageSize: 4, express_id: id}, 'post')
            if (data.code == 0) {
                this.productList = data.data.list
            }
        },
        selectEvent(id) {
            this.select = id
            this.getProduct(id)
        }
    },
    mounted () {
        this.warehouseList = this.wareHouse
        this.select = this.warehouseList[0].id
        this.getProduct(this.warehouseList[0].id)
    },
}
</script>

<style lang="scss" scoped>
.item {
    border: 1px solid #ddd;
    // width: 175px;
    flex-basis: 200px;
    // margin: 0 12px 0 0;
    & + .item {
        margin-left: 20px;
    }
    img {
        width: 100%;
        height: 180px;
        min-height: 180px;
    }
    .intro {
        padding: 10px;
    }
}
.more-pr {
    height: 10px;
    position: relative;
    top: -4px;
}
</style>